import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
const benefits = [{
  text: 'От кого ещё ждём оплату'
}, {
  text: 'Кто уже совершил оплату'
}, {
  text: 'Сколько было потрачено на закуп продуктов'
}, {
  text: 'Кто пришёл / не пришёл из воспитанников и сотрудников'
}, {
  text: 'Все филиалы в одном месте'
}];
type Tab = 'web' | 'mobile';
function PillSwitch({
  active,
  onChange
}: {
  active: Tab;
  onChange: (t: Tab) => void;
}) {
  return <div className="inline-flex items-center rounded-full bg-white/80 backdrop-blur-md border border-gray-200 p-1 shadow-md" data-id="element-69">
      <button onClick={() => onChange('mobile')} className={`relative px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${active === 'mobile' ? 'bg-[#7C4DFF] text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-70">
        Мобильное приложение
      </button>
      <button onClick={() => onChange('web')} className={`relative px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${active === 'web' ? 'bg-[#7C4DFF] text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-71">
        Веб-платформа
      </button>
    </div>;
}
function CtaPair() {
  return <div className="mt-8 flex flex-col sm:flex-row items-start gap-3" data-id="element-72">
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#7C4DFF] text-white font-medium text-base shadow-lg hover:bg-[#651FFF] transition-all" data-id="element-73">
        Узнать подробнее
      </a>
      <span className="inline-flex items-center px-5 py-2.5 rounded-full text-sm font-medium text-gray-600 bg-gray-100 border border-gray-200" data-id="element-74">
        20 000 ₸ / в месяц
      </span>
    </div>;
}
export function DashboardSection() {
  const [activeTab, setActiveTab] = useState<Tab>('web');
  const previewRef = useRevealOnScroll<HTMLDivElement>(0, 0.15);
  return <section className="pt-24 pb-0 bg-white overflow-hidden" id="solutions" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        {/* Section intro */}
        <div className="text-center mb-16" data-id="element-77">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-[#7C4DFF] mb-3" data-id="element-78">
            Решения
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E]" data-id="element-79">
            Всё управление — в одной системе
          </h2>
        </div>

        {/* Module card */}
        <div className="rounded-3xl border border-gray-100 bg-[#FAFAFA] shadow-sm overflow-hidden" data-id="element-80">
          <div className="px-6 py-3 border-b border-gray-100 flex items-center gap-3" data-id="element-81">
            <span className="text-xs font-bold text-gray-300 tracking-widest font-mono" data-id="element-82">
              01 / 05
            </span>
            <span className="text-xs font-semibold tracking-widest uppercase text-[#7C4DFF]" data-id="element-83">
              Дашборд руководителя
            </span>
          </div>
          <div className="p-6 lg:p-10" data-id="element-84">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-85">
              {/* Preview — LEFT on desktop */}
              <div className="relative lg:order-1" data-id="element-86">
                <div ref={previewRef} className="reveal-visual visual-hover-lift relative min-h-[360px] sm:min-h-[420px] flex items-center justify-center" data-id="element-87">
                  <div className={`w-full transition-all duration-300 ${activeTab === 'web' ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'}`} data-id="element-88">
                    <div className="rounded-2xl shadow-2xl border border-gray-200 overflow-hidden bg-white" data-id="element-89">
                      <div className="h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 space-x-2" data-id="element-90">
                        <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-91" />
                        <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-92" />
                        <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-93" />
                      </div>
                      <img src="https://cdn.magicpatterns.com/uploads/7Tan4tCoZC26N1PHqU6F5U/панель_для_руководителя.png" alt="Дашборд руководителя — веб" className="w-full h-auto" data-id="element-94" />
                    </div>
                  </div>
                  <div className={`w-full flex justify-center transition-all duration-300 ${activeTab === 'mobile' ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'}`} data-id="element-95">
                    <img src="https://cdn.magicpatterns.com/uploads/smrKEtBgxHCGSuzY8xQDnA/Mockuuups_Free_iPhone_Hand_Mockup.png" alt="Мобильное приложение Meelo" className="max-h-[420px] w-auto object-contain drop-shadow-2xl" data-id="element-96" />
                  </div>
                  <div className="absolute bottom-4 left-0 right-0 flex justify-center z-10" data-id="element-97">
                    <PillSwitch active={activeTab} onChange={setActiveTab} data-id="element-98" />
                  </div>
                </div>
              </div>

              {/* Text — RIGHT on desktop */}
              <div className="lg:order-2" data-id="element-99">
                <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-[#1A1A2E] leading-tight mb-6" data-id="element-100">
                  Вся важная информация — всегда под рукой
                </h2>
                <ul className="space-y-4 mb-4" data-id="element-101">
                  {benefits.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-102">
                      <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#EDE7F6] flex items-center justify-center mt-0.5" data-id="element-103">
                        <Check className="w-3.5 h-3.5 text-[#7C4DFF]" strokeWidth={3} data-id="element-104" />
                      </div>
                      <span className="text-gray-700 text-base leading-relaxed" data-id="element-105">
                        {item.text}
                      </span>
                    </li>)}
                </ul>
                <CtaPair data-id="element-106" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}